"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCellStyle = exports.mapLocalization = exports.compareOpts = void 0;
var fp = require("fp-ts");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
exports.compareOpts = {
    numeric: true,
    sensitivity: 'base'
};
exports.mapLocalization = fp.function.flow(String, translation_1.getLocalization);
var createCellStyle = function (pixelWidth) { return ({
    width: "".concat(pixelWidth, "px"),
    minWidth: "".concat(pixelWidth, "px"),
    maxWidth: "".concat(pixelWidth, "px")
}); };
exports.createCellStyle = createCellStyle;
